<p-table #dt styleClass="p-datatable-responsive-demo" [value]="venueInternetHistory">
	<ng-template pTemplate="caption" #caption>
		<div class="table-header d-flex p-grid">
			<div class="p-col-12 p-md-6 p-lg-3">
				<h2>Internet History</h2>
			</div>
			<div class="p-col-12 p-md-6 p-lg-3">
				<h4>Last 24 hours: {{ this.last24hrs }}</h4>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header" #header>
		<tr>
			<td>Incident</td>
			<td>Duration</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" #body let-rec let-idx="index">
		<tr>
			<td>
				<span class="p-column-title">Incident</span>
				{{ moment(rec.disconnectDateTime).format("lll") }}
			</td>
			<td>
				<span class="p-column-title">Duration</span>
				{{ moment(rec.disconnectDateTime).from(moment(rec.disconnectDateTime).add(rec.duration, "seconds"), true) }}
			</td>
		</tr>
	</ng-template>
</p-table>
